module.exports = __webpack_public_path__ + "media/signup-react/email-a1b9773e.svg";